export const HealthCheck = () => {
  return "";
};
